import { defineComponent } from 'navigation-components/platform/models';
import { args } from 'navigation-components/common/args';
import { GROWTH_PROMPTS_COMPONENT, Tags } from '../constants';
import { getPortalId } from '../../common/utils';
import { growthPromptsStyle } from './internal/styles';
import { getProjectName } from 'navigation-components/common/utils';
export const growthPromptsComponentDef = defineComponent(GROWTH_PROMPTS_COMPONENT, {
  name: GROWTH_PROMPTS_COMPONENT,
  path: `/growth-prompts/${getPortalId()}`,
  capabilities: [],
  iframeProps: {
    style: growthPromptsStyle,
    id: 'growth-prompts',
    ['data-test-id']: 'growth-prompts-iframe',
    title: 'growth-prompts-iframe'
  },
  queryParams: {
    hostProjectName: getProjectName()
  },
  propsSchema: {
    // Used to determine if the Navigation component iframe should be shown
    hasPromptsToShow: args.bool(),
    // This is used to pass the window.location.href to the iframe
    hostUrl: args.string()
  },
  initialProps: {
    hasPromptsToShow: false,
    hostUrl: ''
  },
  deferLoading: true,
  initiallyOpen: false,
  tags: [Tags.MODAL]
});